import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import RootSaga from "./sagas";
import Reducer from "./reducers";
import createSagaMiddleware from "redux-saga";

export const history = createBrowserHistory();

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// dev tools middleware

let Middlewares = compose(
    applyMiddleware(routerMiddleware(history), sagaMiddleware)
);
if (process.env.NODE_ENV === "development") {
    let reduxDevTools =
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        window.__REDUX_DEVTOOLS_EXTENSION__();

    if(reduxDevTools) {        
        Middlewares = compose(
            applyMiddleware(routerMiddleware(history), sagaMiddleware),
            reduxDevTools
        );
    } else {
        Middlewares = compose(
            applyMiddleware(routerMiddleware(history), sagaMiddleware)            
        );
    }
}

function configureStore() {
    const store = createStore(
        Reducer(history),
        Middlewares
    );
    // run the saga
    sagaMiddleware.run(RootSaga);
    return store;
}

export default configureStore();